/** The React Query devtools are developer chrome: they never render on the installer's phone page (/t/:token). */
export function showQueryDevtools(pathname: string): boolean {
  return !pathname.startsWith('/t/');
}
